<template>
  <div class="container article-panel">
    <div v-if="platformCategory">
      <browse-knowledge :key="componentKey"></browse-knowledge>
    </div>
  </div>
</template>

<script>
import { safeImportComponent } from "@/utils/componentImportUtils";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as CONSTANTS from "@/store/constants";
import BrowseKnowledge from "@/components/knowledge-article/BrowseKnowledge.vue";
import router from "../../router";
import Velocity from "velocity-animate";

export default {
  name: "BrowseArticle",
  data() {
    return {
      componentKey: 0,
      hrPlatform: CONSTANTS.HR_PLATFORM
    };
  },
  components: {
    BrowseKnowledge
  },
  computed: {
    ...mapGetters([
      "platformCategories",
      "platformCategory",
      "errorMessage",
      "user",
      "country",
      "articlesLoading",
      "standardContentAccessible"
    ]),
    checkHrPlatform: function() {
      return this.platformCategory === this.hrPlatform;
    }
  },
  watch: {
    "user.userName": function() {
      this.init();
      this.componentKey++;
    },
    country: function() {
      this.init();
      this.componentKey++;
    },
    errorMessage: function() {
      if (this.errorMessage && this.errorMessage.length) {
        this.$router.push({ name: "page-not-found" });
      }
    }
  },
  created() {
    let that = this;
    this.fetchPlatformCategories().then(() => {
      that.init();
    });
  },
  methods: {
    ...mapActions(["fetchPlatformCategories", "setBannerErrorMessage"]),
    ...mapMutations(["setPlatformCategory"]),
    init() {
      if (this.$route.params.platformCategory) {
        let platform = this.$route.params.platformCategory.toUpperCase();

        let platformObj = this.platformCategories.find(
          item => item.alias === platform
        );
        if (!platformObj) {
          this.$router.push({ name: "page-not-found" });
          this.setBannerErrorMessage(CONSTANTS.INVALID_PLATFORM);
          return;
        } else {
          document.title = `${platformObj.name} Knowledge articles for KB Browse -   Autodesk One`;
          this.setPlatformCategory(platform);
        }

        // If STANDARD type and not accessible give a forbidden page
        if (platformObj.type == "STANDARD" && !this.standardContentAccessible) {
          router.push({ name: "Forbidden" });
        }
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 1s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.alert {
  border-radius: 0;
}

.article-panel {
  background: #ffffff;
  min-height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/components/knowledge-article/BrowseArticle.vue